import { useRef } from 'react'
import { StickyTableScrollbar } from '@/components/ui/StickyTableScrollbar'
import { cn } from '@lib/utils/helpers'
import reportStyles from '../styles/reportsTable.module.css'
import type { ReportTableScrollProps } from '../types/components'

export function ReportTableScroll({
  children,
  className,
  enabled = true,
  testIdPrefix = 'report',
}: ReportTableScrollProps) {
  const scrollRef = useRef<HTMLDivElement | null>(null)

  return (
    <>
      <div
        ref={scrollRef}
        className={cn(
          reportStyles.tableResponsiveScroll,
          'min-w-0 w-full',
          className,
        )}
        data-testid={`${testIdPrefix}-results-scroll`}
      >
        {children}
      </div>
      {enabled ? (
        <StickyTableScrollbar
          containerRef={scrollRef}
          data-testid={`${testIdPrefix}-table-sticky-scrollbar`}
        />
      ) : null}
    </>
  )
}

export type { ReportTableScrollProps }
